// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const Input = createStyle({
  borderWidth: 1,
  borderColor: '$borderLight',
  borderRadius: '$sm',
  flexDirection: 'row',
  overflow: 'hidden',
  alignContent: 'center',
  backgroundColor: '$bgCard',

  ':hover': {
    borderColor: '$borderMedium',
  },

  ':focus': {
    borderColor: '$borderFocus',
    ':hover': {
      borderColor: '$borderFocus',
    },
  },

  ':disabled': {
    opacity: 0.4,
    ':hover': {
      borderColor: '$borderLight',
    },
  },

  _input: {
    py: 'auto',
    px: '$3',
    overflow: 'hidden',
  },

  _icon: {
    color: '$textHint',
  },

  _dark: {
    borderColor: '$borderLight',
    backgroundColor: '$bgCard',
    ':hover': {
      borderColor: '$borderMedium',
    },
    ':focus': {
      borderColor: '$borderFocus',
      ':hover': {
        borderColor: '$borderFocus',
      },
    },
    ':disabled': {
      ':hover': {
        borderColor: '$borderLight',
      },
    },
  },

  variants: {
    size: {
      xl: {
        h: '$12',
        _input: {
          props: {
            size: 'xl',
          },
        },
        _icon: {
          props: {
            size: 'xl',
          },
        },
      },
      lg: {
        h: '$11',
        _input: {
          props: {
            size: 'lg',
          },
        },
        _icon: {
          props: {
            size: 'lg',
          },
        },
      },
      md: {
        h: '$10',
        _input: {
          props: {
            size: 'md',
          },
        },
        _icon: {
          props: {
            size: 'sm',
          },
        },
      },
      sm: {
        h: '$9',
        _input: {
          props: {
            size: 'sm',
          },
        },
        _icon: {
          props: {
            size: 'xs',
          },
        },
      },
      xs: {
        h: '$8',
        _input: {
          props: {
            size: 'xs',
          },
        },
        _icon: {
          props: {
            size: '2xs',
          },
        },
      },
    },
    variant: {
      underlined: {
        _input: {
          _web: {
            outlineWidth: 0,
            outline: 'none',
          },
          px: '$0',
        },
        borderWidth: 0,
        borderRadius: 0,
        borderBottomWidth: '$1',
        ':focus': {
          borderColor: '$borderFocus',
          _web: {
            boxShadow: 'inset 0 -1px 0 0 $borderFocus',
          },
        },
        ':invalid': {
          borderBottomWidth: 2,
          borderBottomColor: '$statusError',
          _web: {
            boxShadow: 'inset 0 -1px 0 0 $statusError',
          },
          ':hover': {
            borderBottomColor: '$statusError',
          },
          ':focus': {
            borderBottomColor: '$statusError',
            ':hover': {
              borderBottomColor: '$statusError',
              _web: {
                boxShadow: 'inset 0 -1px 0 0 $statusError',
              },
            },
          },
          ':disabled': {
            ':hover': {
              borderBottomColor: '$statusError',
              _web: {
                boxShadow: 'inset 0 -1px 0 0 $statusError',
              },
            },
          },
        },
        _dark: {
          ':focus': {
            borderColor: '$borderFocus',
            _web: {
              boxShadow: 'inset 0 -1px 0 0 $borderFocus',
            },
          },
          ':invalid': {
            borderColor: '$statusError',
            _web: {
              boxShadow: 'inset 0 -1px 0 0 $statusError',
            },
            ':hover': {
              borderBottomColor: '$statusError',
            },
            ':focus': {
              borderBottomColor: '$statusError',
              ':hover': {
                borderBottomColor: '$statusError',
                _web: {
                  boxShadow: 'inset 0 -1px 0 0 $statusError',
                },
              },
            },
            ':disabled': {
              ':hover': {
                borderBottomColor: '$statusError',
                _web: {
                  boxShadow: 'inset 0 -1px 0 0 $statusError',
                },
              },
            },
          },
        },
      },

      outline: {
        _input: {
          _web: {
            outlineWidth: 0,
            outline: 'none',
          },
        },
        ':focus': {
          borderColor: '$borderFocus',
          _web: {
            boxShadow: 'inset 0 0 0 1px $borderFocus',
          },
        },
        ':invalid': {
          borderColor: '$statusError',
          _web: {
            boxShadow: 'inset 0 0 0 1px $statusError',
          },
          ':hover': {
            borderColor: '$statusError',
          },
          ':focus': {
            borderColor: '$statusError',
            ':hover': {
              borderColor: '$statusError',
              _web: {
                boxShadow: 'inset 0 0 0 1px $statusError',
              },
            },
          },
          ':disabled': {
            ':hover': {
              borderColor: '$statusError',
              _web: {
                boxShadow: 'inset 0 0 0 1px $statusError',
              },
            },
          },
        },
        _dark: {
          ':focus': {
            borderColor: '$borderFocus',
            _web: {
              boxShadow: 'inset 0 0 0 1px $borderFocus',
            },
          },
          ':invalid': {
            borderColor: '$statusError',
            _web: {
              boxShadow: 'inset 0 0 0 1px $statusError',
            },
            ':hover': {
              borderColor: '$statusError',
            },
            ':focus': {
              borderColor: '$statusError',
              ':hover': {
                borderColor: '$statusError',
                _web: {
                  boxShadow: 'inset 0 0 0 1px $statusError',
                },
              },
            },
            ':disabled': {
              ':hover': {
                borderColor: '$statusError',
                _web: {
                  boxShadow: 'inset 0 0 0 1px $statusError',
                },
              },
            },
          },
        },
      },

      rounded: {
        borderRadius: 999,
        _input: {
          px: '$4',
          _web: {
            outlineWidth: 0,
            outline: 'none',
          },
        },
        ':focus': {
          borderColor: '$borderFocus',
          _web: {
            boxShadow: 'inset 0 0 0 1px $borderFocus',
          },
        },
        ':invalid': {
          borderColor: '$statusError',
          _web: {
            boxShadow: 'inset 0 0 0 1px $statusError',
          },
          ':hover': {
            borderColor: '$statusError',
          },
          ':focus': {
            borderColor: '$statusError',
            ':hover': {
              borderColor: '$statusError',
              _web: {
                boxShadow: 'inset 0 0 0 1px $statusError',
              },
            },
          },
          ':disabled': {
            ':hover': {
              borderColor: '$statusError',
              _web: {
                boxShadow: 'inset 0 0 0 1px $statusError',
              },
            },
          },
        },

        _dark: {
          ':focus': {
            borderColor: '$borderFocus',
            _web: {
              boxShadow: 'inset 0 0 0 1px $borderFocus',
            },
          },
          ':invalid': {
            borderColor: '$statusError',
            _web: {
              boxShadow: 'inset 0 0 0 1px $statusError',
            },
            ':hover': {
              borderColor: '$statusError',
            },
            ':focus': {
              borderColor: '$statusError',
              ':hover': {
                borderColor: '$statusError',
                _web: {
                  boxShadow: 'inset 0 0 0 1px $statusError',
                },
              },
            },
            ':disabled': {
              ':hover': {
                borderColor: '$statusError',
                _web: {
                  boxShadow: 'inset 0 0 0 1px $statusError',
                },
              },
            },
          },
        },
      },
    },
  },

  defaultProps: {
    size: 'md',
    variant: 'outline',
  },
});
